var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPattern1Light(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 618,
    height: 653,
    viewBox: "0 0 618 653",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 463.5H160C182.091 463.5 200 481.409 200 503.5V612.5C200 634.591 217.909 652.5 240 652.5H425C447.091 652.5 465 634.591 465 612.5V409C465 386.909 482.909 369 505 369H577C599.091 369 617 386.909 617 409V490.5C617 512.591 599.091 530.5 577 530.5H334.403C312.311 530.5 294.403 512.591 294.403 490.5V437.5V315.153C294.403 293.061 276.494 275.153 254.403 275.153H219C196.909 275.153 179 293.061 179 315.153V340.201C179 362.292 196.909 380.201 219 380.201H383.195C405.286 380.201 423.195 362.292 423.195 340.201V164.902C423.195 142.811 441.103 124.902 463.195 124.902H519C541.091 124.902 559 142.811 559 164.902V212.233C559 234.325 541.091 252.233 519 252.233H381.584C359.493 252.233 341.584 234.324 341.584 212.233V81.5C341.584 59.4086 323.675 41.5 301.584 41.5H76.5C54.4086 41.5 36.5 59.4086 36.5 81.5V191.5C36.5 213.591 54.4086 231.5 76.5 231.5H160C182.091 231.5 200 213.591 200 191.5V0",
    stroke: "url(#paint0_radial_993_78219)",
    strokeOpacity: 0.08
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_993_78219",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(358.799 271.333) rotate(90) scale(743.667 713.62)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern1Light);
export default __webpack_public_path__ + "static/media/pattern1-light.568da3886f833fd1305e77acbdee5d45.svg";
export { ForwardRef as ReactComponent };